(function() {

    'use strict';

    var MeasureMyselfCmp = {
        controllerAs: '$ctrl',
        templateUrl: 'measure-myself.component.html',
        controller: MeasureMyselfCtrl,
        bindings: {
            product: '<',
            goToEquivalence: '&'
        }
    };

    MeasureMyselfCtrl.$inject = ['ItxScreenSizeSvc'];

    function MeasureMyselfCtrl(ItxScreenSizeSvc) {

        var _this = this;
        _this.ItxScreenSizeSvc = ItxScreenSizeSvc;
        
    }

    angular.module('itxApp.common')
        .component('measureMyself', MeasureMyselfCmp);

})();